import React, {useState} from 'react'
import { Link } from 'react-router-dom'
import {XLg} from 'react-bootstrap-icons'


export default function Header() {

    const [isExpanded, setIsExpanded] = useState(false);

    const toggleButton = () => {
      setIsExpanded(!isExpanded);
    };

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light nav-pd">
                <Link className="navbar-brand" to="#">Blogger</Link>
                <button className="navbar-toggler" onClick={toggleButton} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    {isExpanded ? <span><XLg/></span> : <span className="navbar-toggler-icon"></span>}
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link" to="/">Home</Link>
                        </li>
                    </ul>
                    <ul className="navbar-nav ml-auto nav-post">
                        <li className="nav-item">
                            <Link className="nav-link" to="/Createblogbyuser">Create Post</Link>
                        </li>
                    </ul>
                </div>

            </nav>
        </div>
    )
}
